"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJwtPayload = void 0;
const logging_1 = require("./logging");
// inspired by https://github.com/auth0/jwt-decode (MIT License)
// not adding dep because they include unneeded polyfill and other behaviors we don't need
const prepareJwtPart = (part) => {
    let prepared = part.replace(/-/g, '+').replace(/_/g, '/');
    switch (prepared.length % 4) {
        case 0:
            break;
        case 2:
            prepared += '==';
            break;
        case 3:
            prepared += '=';
            break;
        default:
            return undefined;
    }
    return prepared;
};
const decodeJwtPart = (part) => {
    let decodedPayloadPart;
    try {
        decodedPayloadPart = decodeURIComponent(window.atob(part).replace(/(.)/g, (_, matchedPart) => {
            let code = matchedPart.charCodeAt(0).toString(16).toUpperCase();
            // codes < 2 (often checked in these decoding algos) are not valid for JSON
            // so we skip that check and just assume valid JSON for JWT payload
            return '%' + code;
        }));
    }
    catch (ex) {
        return ex; // these are the only two types of errors that can be thrown
    }
    return decodedPayloadPart;
};
const parseJwtPart = (part) => {
    try {
        return JSON.parse(part);
    }
    catch (ex) {
        return ex; // this is the only type of error that can be thrown
    }
};
/**
 * Parse the payload portion of a JWT.
 *
 * Returns undefined if the token is not properly formatted or cannot be parsed.
 *
 * Logs errors to the console if there are problems.
 *
 * @param jwt - should be Base64-Encoded with parts: header.payload.signature
 */
const parseJwtPayload = (jwt) => {
    if (typeof jwt !== 'string' || (jwt = jwt.trim()).length === 0) {
        (0, logging_1.error)('No/empty/invalid type of JWT provided. Token Received:', jwt);
        return;
    }
    const rawPayloadPart = jwt.split('.')[1];
    if (!rawPayloadPart) {
        (0, logging_1.error)('Missing payload portion. Expected format: header.payload.signature. JWT Received:', jwt);
        return;
    }
    const preparedPayloadPart = prepareJwtPart(rawPayloadPart);
    if (typeof preparedPayloadPart !== 'string') {
        (0, logging_1.error)(`Payload base64 JWT part is not of the correct length. Received: '${rawPayloadPart}'`);
        return;
    }
    const decodedPayloadPart = decodeJwtPart(preparedPayloadPart);
    if (typeof decodedPayloadPart !== 'string') {
        (0, logging_1.error)(`Unable to decode JWT payload. Received: '${rawPayloadPart}'; Prepared: '${preparedPayloadPart}'. Result:`, decodedPayloadPart);
        return;
    }
    const parsedPayload = parseJwtPart(decodedPayloadPart);
    if (parsedPayload instanceof Error) {
        (0, logging_1.error)(`Unable to parse JWT payload. Received: '${rawPayloadPart}'; Prepared: '${preparedPayloadPart}'; Decoded: '${decodedPayloadPart}'. Result:`, parsedPayload);
        return;
    }
    (0, logging_1.verbose)('Parsed JWT Payload:', parsedPayload);
    return parsedPayload;
};
exports.parseJwtPayload = parseJwtPayload;
